import React, { useCallback } from "react";
import {
  Box,
  AddOutlined,
  useState,
  useEffect,
} from "../../../../Collections/Imports";
import { useDispatch, useSelector } from "react-redux";
import { useApiCallMutation } from "../../../../Services/ApiCallService";
import AgGridComponent from "../../../../Components/CommonComponents/AG-Grid";
import AddEditPublisherPingtree from "../../../../Forms/AddEditPublisherPingtree";
import {
  getData,
  removeData,
} from "../../../../Store/PublisherModule/publisherPingtreeSetting";
import { publisherModuleApiEndPoints } from "../../../../Config/APIsEndpoints";
import CircularProgressBar from "../../../../Components/UIComponents/CircularProgressBar";
import { updateSnackBarConfig } from "../../../../Store/Global/SnackBar";
import Icon from "@mdi/react";
import { mdiPencil, mdiDelete } from "@mdi/js";
import ConfirmDialog from "../../../../Components/CommonComponents/ConfirmModal/ConfirmDialog";
import "../../../../Components/CommonComponents/AG-Grid/agGrid.css";
let userPermissions = JSON.parse(localStorage.getItem("userInfo"));

const actions = ["EDIT", "DELETE"];
const tableName = "Distribution By Publisher";

const handleCustomDisabled = (data) => !data?.isDeleted;

class ShowCellRenderer {
  init(params) {
    const cellBlank = !params.value;
    if (params.data.count === undefined) {
      return null;
    }

    this.ui = document.createElement("div");
    this.ui.innerHTML =
      '<div class="show-name" style="border-top:1px solid #d2cfcf">' +
      params.data[params.column.colId] +
      "" +
      "</div>";
  }

  getGui() {
    return this.ui;
  }

  refresh() {
    return false;
  }
}

function PubPingtreeSetting() {
  const dispatch = useDispatch();
  const [isOpenAddEditBox, setIsOpenAddEditBox] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [rowSelected, setRowSelected] = useState({});
  const [rowData, setRowData] = useState("");
  const [itemPerIndex, setItemPerIndex] = useState(100);
  const [paginationIndex, setPaginationIndex] = useState(0);
  const perPageCountOptions = [
    { label: "100", value: 100 },
    { label: "500", value: 500 },
    { label: "1000", value: 1000 },
  ];
  const [GetPubPingtree, getPubPingtreeData] = useApiCallMutation();
  const [DeletePubPingtree, DeletePubPingtreeData] = useApiCallMutation();
  let currentPubData = JSON.parse(
    sessionStorage.getItem("currentPublisherData")
  );
  const PingtreeSettingRowData = useSelector(
    (state) => state.publisherPingtreeSetting?.data?.pubPingtree
  );
  // DELETE CONFIRMATION
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  // Transform the array into the desired format
  const tableData = PingtreeSettingRowData?.pubPingTreeSetting?.flatMap(
    (item) => {
      const pingTrees = item.pingTrees || item.pingTrees || [];

      const pingTreeKeyValuePairs = pingTrees.reduce(
        (acc, { pingTreeId, value }) => {
          acc[`pingtree-${pingTreeId}`] = `${value}`;
          return acc;
        },
        {}
      );
      // console.log("pingTreeKeyValuePairs", pingTreeKeyValuePairs);
      const count = pingTrees.length;

      return pingTrees.map((pingTree, index) => ({
        ...pingTreeKeyValuePairs,
        ptsUniqueId: item?.ptsUniqueId || item.ptsUniqueId || "",
        pingTreeType: item?.pingTreeType || item.pingTreeType || "",
        channelName: item?.channelName || item.channelName || "",
        channelUniqueId: item?.channelUniqueId || item.channelUniqueId || "",
        pingTreeId: pingTree.pingTreeId,
        pingtreeName: pingTree.pingTreeName,
        value: pingTree.value,
        createdOn: item?.createdOn || item.createdOn || "",
        status: item?.status || item.status || "",
        count: index === 0 ? count : undefined, // Include count only for the first element
        pingTrees: item.pingTrees,
        rowSpan: index === 0 ? count : 1, // Set rowSpan only for the first entry
        actionVisible: index === 0, // Add flag for action visibility
        id: item.Id,
      }));
    }
  );
  // Handle Grid Button ACtion
  const handleActions = (previousData, action) => {
    switch (action) {
      case "EDIT":
        setRowSelected(previousData);
        setIsEditMode(true);
        setIsOpenAddEditBox(true);

        break;
      case "DELETE":
        DeletePubPingtree({
          endPoint: publisherModuleApiEndPoints.deleteTreeSetting,
          method: "POST",
          // data: { data: listId },

          data: {
            data: {
              ptsUniqueId: previousData.ptsUniqueId,
            },
          },
        });
        dispatch(removeData(previousData.ptsUniqueId));
        dispatch(
          updateSnackBarConfig({
            open: true,
            color: "success",
            message: "Data deleted successfully",
          })
        );
        break;
    }
  };
  const executeActions = (data, action) => {
    if (action) {
      handleActions(data, action);
      setConfirmDialog({ isOpen: false });
    }
  };

  const rowStyle = { background: "" };

  const actionButtons = useCallback(
    (params) => {
      const isVisible = params.data.actionVisible;

      if (params.data.count === undefined) {
        return null;
      }
      return (
        isVisible && (
          <div className="custom-row-span">
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingTop: "6px",
              }}
            >
              {actions.includes("EDIT") && (
                <Icon
                  path={mdiPencil}
                  title="Edit"
                  onClick={() => {
                    if (
                      userPermissions.permissions.includes("Modify Content") ||
                      (userPermissions.roles[0] === "admin" &&
                        handleCustomDisabled(params.data))
                    ) {
                      handleActions(params.data, "EDIT");
                    }
                  }}
                  size={1}
                  style={{
                    color: "#0c247b",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                />
              )}
              {typeof actions !== "undefined" && actions.includes("DELETE") && (
                <Icon
                  path={mdiDelete}
                  title="Delete"
                  onClick={() => {
                    if (
                      userPermissions?.permissions?.includes(
                        "Delete Content"
                      ) ||
                      (userPermissions?.roles[0] === "admin" &&
                        handleCustomDisabled(params?.data))
                    ) {
                      setConfirmDialog({
                        isOpen: true,
                        title: `Are you sure you want to delete this ${tableName}`,
                        subTitle: "You can't undo this operation",
                        onConfirm: () => {
                          executeActions(params.data, "DELETE");
                        },
                      });
                    }
                  }}
                  size={1}
                  style={{
                    color: "#0c247b",
                    display: params.data?.isDeleted ? "none" : "inline-block",
                    opacity:
                      userPermissions?.permissions?.includes(
                        "Delete Content"
                      ) ||
                      (userPermissions?.roles[0] === "admin" &&
                        handleCustomDisabled(params?.data))
                        ? 1
                        : 0.5,
                    cursor:
                      userPermissions?.permissions?.includes(
                        "Delete Content"
                      ) ||
                      (userPermissions?.roles[0] === "admin" &&
                        handleCustomDisabled(params?.data))
                        ? "pointer"
                        : "not-allowed",
                  }}
                />
              )}
            </Box>
          </div>
        )
      );
    },
    [handleActions, userPermissions, actions, handleCustomDisabled, tableName]
  );

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "pingTreeType",
      rowSpan: function (params) {
        return params.data.rowSpan;
      },
      cellClassRules: {
        "show-cell": "value !== undefined",
        "row-span-border": (params) =>
          params.node.rowIndex % params.data.rowSpan === 0,
        "row-span-border-last": (params) =>
          (params.node.rowIndex + 1) % params.data.rowSpan === 0 &&
          params.data.rowSpan > 1,
      },
      cellDataType: false,
    },
    {
      headerName: "Channel",
      field: "channelName",
      filter: true,
      rowSpan: function (params) {
        return params.data.rowSpan;
      },
      cellClassRules: {
        "show-cell": "value !== undefined",
        "row-span-border": (params) =>
          params.node.rowIndex % params.data.rowSpan === 0,
        "row-span-border-last": (params) =>
          (params.node.rowIndex + 1) % params.data.rowSpan === 0 &&
          params.data.rowSpan > 1,
      },
    },
    {
      headerName: "PingTree Name",
      field: "pingtreeName",
      width: 200,
    },
    {
      headerName: "Distribution",
      field: "value",
      filter: true,
    },
    {
      headerName: "Action",
      field: "Action",
      cellRenderer: (params) =>
        actionButtons({ ...params, rowSpanValue: params.data.rowSpan }), // Pass rowSpanValue directly
      rowSpan: function (params) {
        return params.data.rowSpan;
      },
      cellClassRules: {
        "row-span-border": (params) =>
          params.node.rowIndex % params.data.rowSpan === 0,
        "row-span-border-last": (params) =>
          (params.node.rowIndex + 1) % params.data.rowSpan === 0 &&
          params.data.rowSpan > 1,
      },
      cellStyle: {
        backgroundColor: "#f1f2f4",
      },
    },
  ]);

  const onGridReady = useCallback((params) => {
    setRowData(tableData);
  }, []);

  useEffect(() => {
    GetPubPingtree({
      endPoint: publisherModuleApiEndPoints.getTreeSetting,
      method: "POST",
      data: {
        data: {
          pubUniqueId: currentPubData.pubUniqueId,
        },
      },
    });
  }, [paginationIndex, itemPerIndex]);

  useEffect(() => {
    if (
      getPubPingtreeData?.isSuccess &&
      getPubPingtreeData?.data?.data?.pubPingTreeSetting?.length
    ) {
      dispatch(getData(getPubPingtreeData?.data?.data));
    }
  }, [getPubPingtreeData]);

  return (
    <>
      <Box
        sx={{
          padding: "22px",
        }}
      >
        <Box>
          {isOpenAddEditBox && (
            <AddEditPublisherPingtree
              defaultValues={rowSelected}
              isOpen={isOpenAddEditBox}
              setOpen={setIsOpenAddEditBox}
              isEditMode={isEditMode}
              setIsEditMode={setIsEditMode}
            />
          )}
        </Box>
        {/* Data Table Start */}
        {getPubPingtreeData.status === "isUninitialized" && (
          <CircularProgressBar />
        )}
        {getPubPingtreeData.status !== "isUninitialized" && (
          <AgGridComponent
            // suppressRowTransform={true}
            rowData={tableData || []}
            columnDefs={columnDefs || []}
            performAction={handleActions}
            actionButtons={actionButtons}
            // search={false}
            //columnDefs={[]}
            search={false}
            addActionIcon={<AddOutlined />}
            addAction={setIsOpenAddEditBox}
            AddButtonName={"Add New Distribution Setting"}
            downlodBtn={false}
            tableName={"Distribution By Publisher"}
            // actions={["EDIT", "DELETE"]}
            domLayout="autoHeight"
            height={"100%"}
            rowStyle={rowStyle}
            // getRowStyle={getRowStyle}
            rowMode
          />
        )}
      </Box>
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </>
  );
}

export default PubPingtreeSetting;
